// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"656":"profiler","952":"recorder"}[chunkId] || chunkId) + "." + {"592":"9e338f7d","656":"2dfaa17b","952":"2d7f6136"}[chunkId] + ".chunk.js";
};